export default __webpack_public_path__ + "static/media/new-dexynth-logo.18502f5a.png";